import ErrorBoundary from '@/ErrorBoundary';
import Search from '@/Search';
import SearchData from '@/Search/SearchData';
import SearchProviders, { type SearchProviderProps } from '@/SearchProviders';
import HeadTags from '@/SEO/HeadTags';
import WarmVDPCache from '@/WarmVDPCache';
import type { SeoProps } from '~/server-props/contracts';

export type OwnProps = {
  fetchedInventoryOnServer: boolean;
  forProviders: SearchProviderProps;
  forSeo: SeoProps;
};

export default (props: OwnProps) => (
  <ErrorBoundary>
    <SearchProviders {...props.forProviders}>
      <HeadTags />
      <SearchData fetchedInventoryOnServer={props.fetchedInventoryOnServer} />
      <Search initialSeoProps={props.forSeo} />
      <WarmVDPCache />
      <div id="modal-root" />
    </SearchProviders>
  </ErrorBoundary>
);
